import styled from "@boseo/shared/styled";
import { Link } from "gatsby";

export const StyledLink = styled(Link)``;

export const StyledAnchor = styled.a``;
